<template>
  <div>
    <b-modal @close="emitClose" :id="id" :title="title" class="theme-modal" ok-only
             no-close-on-backdrop :ok-title="okButtonText" :cancel-title="$t('message.cancel')" @ok="handleOk">
      <div>
        <h5 class="modal-title w-100 text-center">{{ question }}</h5>
        <p class="mt-2 text-center">{{ message }}</p>
      </div>
    </b-modal>
  </div>
</template>

<script>

export default {
  name: 'ConfirmModal',
  props: {
    okButtonText: {
      type: String,
      default: ''
    },
    id: {
      type: String,
      default: 'confirm_modal'
    }
  },
  data() {
    return {
      record: null,
      title: '',
      question: '',
      message: '',
      callback: '',

    };
  },
  methods: {
    openModal(record, title = '', message = '', question = '', callback = null) {
      this.record = record
      this.title = title
      this.message = message
      this.question = question
      this.callback = callback

      this.$bvModal.show(this.id)
    },
    emitClose() {
      this.$emit('cancel-handle')
    },
    closeModal() {
      this.$bvModal.hide(this.id)
      this.$emit('cancel-handle')
    },
    handleOk() {
      this.$emit('ok-handle', this.record)
    },
  }
}
</script>